//store.js
import Vue from 'vue';

export let store =Vue.observable({
    isShow: true,
    roles: 'admin',
    orgData: {
        status: '',
        orgName: '',
        provinceId: '',
        limitSize: 20
    }
});
export let mutations={
    changeStore(){
        store.isShow= !store.isShow;
    },
    changeOrgData(val) {
        console.log(val)
        store.orgData = val
    }
}